import React from "react";
import "./Styles.scss";

function SyonTargetPerformanceSection({
  targetIRR,
  strategy,
  targetReturnMultiple,
  minimum,
  stage,
}) {
  return (
    <div class="col-12">
      <div class="col-12">
        <div class="row ms-3 me-3">
          <div class="two-by-two-grid rounded horizontal-border">
            <div class="row border-between vertical-border">
              <div class="col-6 two-by-two-grid-item">
                {" "}
                <div class="fund-target-header-text">Target Fund Size</div>{" "}
                <span class="info-text">$50M</span>
              </div>
              <div class="col-6 two-by-two-grid-item">
                {" "}
                <div class="fund-target-header-text">Strategy</div>{" "}
                <span class="info-text">Venture Capital</span>
              </div>
            </div>
            <div class="row border-between">
              <div class="col-6 two-by-two-grid-item">
                <div class="fund-target-header-text">Carried Interest</div>
                <span class="info-text">5% of profit distr.
                </span>
              </div>
              <div class="col-6 two-by-two-grid-item">
                <div class="fund-target-header-text">Target Life</div>
                <span class="info-text">
                8 yrs (1 yr extension)
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0 mb-3">
          <div class="row gx-3"></div>
        </div>
      </div>
    </div>
  );
}
export default SyonTargetPerformanceSection;
